import React, { Component } from 'react'
import { find as _find, map as _map } from 'lodash'
import PropTypes from 'prop-types'

import { Types, Colors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import Card from '../Card'

import CollapsibleItem from './CollapsibleItem/CollapsibleItem'
import styles from './Collapsible.Styles'

class Collapsible extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeSections: [],
    }
  }

  componentDidMount() {
    const { activeSections } = this.props
    activeSections && this.setState({ activeSections })
  }

  componentDidUpdate(prevProps) {
    const { activeSections } = this.props
    if (this.props.activeSections !== prevProps.activeSections) {
      this.setState({ activeSections })
    }
  }


  collapseOnlySelected = (item, list) => {
    if (_find(list, d => d === item)) {
      return []
    }
    return [item]
  }

  selectItem = (itemIndex, activeSections) => {
    this.props.setSelected(itemIndex - 1)
    const _activeSections = this.collapseOnlySelected(itemIndex, activeSections)
    this.setState({ activeSections: _activeSections })
  }

  renderItems = (items, type, activeSections, titleStyle, style, theme) => {
    const listSize = (items || []).length - 1
    return _map(items, (item, index) => {
      const isOpend = _find(activeSections, d => d === index + 1)
      const hasTitle = Boolean(item.card?.title)
      const cardContentContainerStyle = hasTitle ? styles.cardContainerWithTitle: styles.cardContentContainer

      return item.card ? (
        <Card
          shadowLevel={item.card?.shadowLevel || 'none'}
          withTitle={hasTitle}
          selected={index === this.props.selected}
          title={item.card?.title}
          style={[styles.cardStyle, this.props.cardStyle]}
          isContentLoading={this.props.isContentLoading}
          loadingBackgroundColor={Colors.lightOcean}
          loadingForegroundColor={Colors.white}
          contentContainerStyle={cardContentContainerStyle}
        >
          <CollapsibleItem
            key={index + 1}
            icon={item.icon}
            title={item.title}
            titleStyle={titleStyle}
            desc={item.desc}
            status={item.status || null}
            onPress={() => this.selectItem(index + 1, activeSections)}
            onItemPress={() => this.selectItem(index + 1, activeSections)}
            content={item.content}
            type={type} 
            isLastItem={index === listSize}
            disabled={item.disabled}
            isOpend={isOpend}
            index={index}
            isBlinking={item.isBlinking}
            style={{ ...item.style }}
            isLoading={item.isLoading}
          />
        </Card>
      )
        : (
          <CollapsibleItem
            key={index + 1}
            icon={item.icon}
            title={item.title}
            titleStyle={titleStyle}
            desc={item.desc}
            status={item.status || null}
            onPress={() => this.selectItem(index + 1, activeSections)}
            onItemPress={() => this.selectItem(index + 1, activeSections)}
            content={item.content}
            type={type}
            isLastItem={index === listSize}
            disabled={item.disabled}
            isOpend={isOpend}
            index={index}
            isBlinking={item.isBlinking}
            style={style}
            isLoading={item.isLoading}
          />
        )
    })
  }

  render() {
    const { items, type, titleStyle, style, theme } = this.props
    const { activeSections } = this.state
    return (
      <React.Fragment>
        {this.renderItems(items, type, activeSections, titleStyle, style, theme)}
      </React.Fragment>
    )
  }
}

Collapsible.propTypes = {
  items: PropTypes.array,
  type: PropTypes.oneOf([Types.PRIMARY, Types.SECONDARY]),
  activeSections: PropTypes.array,
  titleStyle: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
  ]),
  isContentLoading: PropTypes.bool,
  selected: PropTypes.number,
  setSelected: PropTypes.func,
  withCard: PropTypes.bool,
  cardStyle: PropTypes.object,
  theme: PropTypes.object,
}

Collapsible.defaultProps = {
  items: [],
  type: Types.PRIMARY,
  activeSections: [],
}

export { Collapsible }

export default withTheme(Collapsible)
